import React from "react";
import ScrollAnimation from "react-animate-on-scroll";
import "animate.css/animate.min.css";
import "./Language.css";

function Language({ link, title, color }) {
  return (
    <ScrollAnimation animateIn="animate__flipInX" animateOnce>
      <div className="language" onClick={() => window.open(link)}>
        <h2 style={{ color: `${color}` }}>{title}</h2>
      </div>
    </ScrollAnimation>
  );
}

export default Language;
